/* This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at http://mozilla.org/MPL/2.0/. */

// AUTOGENERATED BY glean_parser v19.1.0. DO NOT EDIT. DO NOT COMMIT.

import EventMetricType from '@mozilla/glean/private/metrics/event';

/**
 * User clicks on the Apple third party link from email first page.
 *
 * Generated from `email.first_apple_oauth_start`.
 */
export const firstAppleOauthStart = new EventMetricType(
  {
    category: 'email',
    name: 'first_apple_oauth_start',
    sendInPings: ['events'],
    lifetime: 'ping',
    disabled: false,
  },
  []
);

/**
 * User types in the email field of the email first page.
 *
 * Generated from `email.first_engage`.
 */
export const firstEngage = new EventMetricType(
  {
    category: 'email',
    name: 'first_engage',
    sendInPings: ['events'],
    lifetime: 'ping',
    disabled: false,
  },
  []
);

/**
 * User clicks on the Google third party link from email first page.
 *
 * Generated from `email.first_google_oauth_start`.
 */
export const firstGoogleOauthStart = new EventMetricType(
  {
    category: 'email',
    name: 'first_google_oauth_start',
    sendInPings: ['events'],
    lifetime: 'ping',
    disabled: false,
  },
  []
);

/**
 * User clicked "Sign in with passkey" on the email-first page; the WebAuthn
 * ceremony is starting and the button is in its loading state.
 *
 * Generated from `email.first_passkey_submit`.
 */
export const firstPasskeySubmit = new EventMetricType(
  {
    category: 'email',
    name: 'first_passkey_submit',
    sendInPings: ['events'],
    lifetime: 'ping',
    disabled: false,
  },
  []
);

/**
 * Passkey sign-in from the email-first page failed and an error was
 * displayed to the user.
 *
 * Generated from `email.first_passkey_submit_frontend_error`.
 */
export const firstPasskeySubmitFrontendError = new EventMetricType<{
  reason?: string;
}>(
  {
    category: 'email',
    name: 'first_passkey_submit_frontend_error',
    sendInPings: ['events'],
    lifetime: 'ping',
    disabled: false,
  },
  ['reason']
);

/**
 * Passkey sign-in from the email-first page completed: the server verified
 * the WebAuthn assertion and a session token was created. An additional
 * password step may follow for Sync users.
 *
 * Generated from `email.first_passkey_submit_success`.
 */
export const firstPasskeySubmitSuccess = new EventMetricType(
  {
    category: 'email',
    name: 'first_passkey_submit_success',
    sendInPings: ['events'],
    lifetime: 'ping',
    disabled: false,
  },
  []
);

/**
 * An email was submitted on the email-first page (either by the user
 * clicking the submit button, or auto-submitted when an email is
 * supplied via query params or a cached account) but email submission
 * failed, likely due to a failed email domain check. The user is not
 * navigated onwards to sign in or sign up.
 *
 * Generated from `email.first_submit_fail`.
 */
export const firstSubmitFail = new EventMetricType<{
  reason?: string;
}>(
  {
    category: 'email',
    name: 'first_submit_fail',
    sendInPings: ['events'],
    lifetime: 'ping',
    disabled: false,
  },
  ['reason']
);

/**
 * An email was submitted on the email first page (either by the user
 * clicking the submit button, or auto-submitted when an email is
 * supplied via query params or a cached account) and the flow is
 * navigated onwards to sign in or sign up.
 *
 * Generated from `email.first_submit_success`.
 */
export const firstSubmitSuccess = new EventMetricType<{
  reason?: string;
}>(
  {
    category: 'email',
    name: 'first_submit_success',
    sendInPings: ['events'],
    lifetime: 'ping',
    disabled: false,
  },
  ['reason']
);

/**
 * Email First Page View
 * A view of the page that prompts the user to enter their email address. From
 * there the user either gets directed to the registration or login flow depending
 * on if their email is registered to an account.'
 *
 * Generated from `email.first_view`.
 */
export const firstView = new EventMetricType(
  {
    category: 'email',
    name: 'first_view',
    sendInPings: ['events'],
    lifetime: 'ping',
    disabled: false,
  },
  []
);
